import { isTypeString } from 'utils/helpers';
import { InsightHeaderProps, INSIGHT_HEADER_WIDTHS } from './InsightPanelHeader';
import { CustomInsightRemovalMenu } from './CustomInsightRemovalMenu';
import { useCustomInsightOptions } from '../../../hooks';
import { CustomPanelWrapper, InsightPanelHeader } from './InsightPanel.styled';

export const CUSTOM_INSIGHT_HEADER = 'custom-insight-header';

export const CustomInsightPanelHeader = ({
  title,
  size,
  showDivider = false,
  type = null,
}: InsightHeaderProps) => {
  const insight = isTypeString(title) ? title : '';
  const options = useCustomInsightOptions(insight, type);

  if (!title) return null;

  return (
    <CustomPanelWrapper data-test={title} data-divider={showDivider} data-size={size}>
      <InsightPanelHeader
        data-test={CUSTOM_INSIGHT_HEADER}
        data-title={insight}
        data-width={type ? INSIGHT_HEADER_WIDTHS[type] : ''}
      >
        {title}
      </InsightPanelHeader>
      <CustomInsightRemovalMenu options={options} />
    </CustomPanelWrapper>
  );
};
